//
// 信息提示框
// ============================================================
import Ns from "./utility";

let messageError = options => Ns.err({
    arg: [{
        name: ["status", "iconClass", "iconColor", "text", "textColor", "el"],
        value: [options.status, options.iconClass, options.iconColor, options.text, options.textColor, options.el],
        typeof: "string",
        isNull: true,
    }, {
        name: "duration",
        value: options.duration,
        typeof: "number",
        isNull: true,
    }, {
        name: "callback",
        value: options.callback,
        typeof: "function",
        isNull: true,
    }],
    method: "Message()",
});

let message = options => {
    if(messageError(options) == "err") return;
    let icon = "";
    switch (options.status) {
        case "info":
            icon = "icon-infofill color-info";
            break;
        case "success":
            icon = "icon-roundcheckfill color-success";
            break;
        case "warning":
            icon = "icon-warnfill color-warning";
            break;
        case "danger":
            icon = "icon-roundclosefill color-danger";
            break;
        default:
            icon = "icon-roundcheckfill color-success";
    }
    options.iconClass ? icon = options.iconClass : "";

    let iconColor2 = options.iconColor ? 'style="color: ' + options.iconColor : '';
    let textColor2 = options.textColor ? 'style="color: ' + options.textColor : '';

    let str = `
                <div class="message-wrapper active">
                    <i class="iconfont ` + icon + `" ` + iconColor2 +`"></i>
                    <div class="message-text" ` + textColor2 + `">` + options.text + `</div>
                </div>`;
    ns("body").append(str);

    let messageWrapper= ns(".message-wrapper");
    setTimeout( () =>  messageWrapper.addClass("unactive"), options.duration);
    setTimeout( () => {
        messageWrapper.remove();
        if (options.callback && typeof options.callback == "function") {
            options.callback();
        }
    }, Number(options.duration) + 500);

    return true;
};



const Message = ({iconClass, iconColor= "", text= "内容君请假了ヾ(｡｀Д´｡)", duration= 2000, el= ".message-button", textColor= "", callback, status, execute} = {}) => {
    new Ns({
        el: el,
        eventHandle: {
            type: "click",
            callback: function (ev) {
                return message({iconClass, iconColor, text, textColor, status, duration, callback});
            }
        },
        callback() {
            if (execute == "auto") {
                return message({iconClass, iconColor, text, textColor, status, duration, callback});
            }
        }
    })
};

module.exports = Message;


// WEBPACK FOOTER //
// src/js/message.js